<section class="mainTopBanner section-pd">
   <div class="container">
      <div class="row">
         <div class="col-lg-12">
            <div class="topBannerWrapper">
               <div class="top-banner-left">
                  <h1 class="trinka-sub-title">翻訳機能</h1>
                  <h2>
                     フォーマットを<br/>
                     保持して<br/>
                     正確に翻訳
                  </h2>
                  <p>
                     30以上の言語を英語またはスペイン語に翻訳。ダウンロード、またはTrinka上での編集が可能です。
                  </p>
                  <div class="btn-group">
                     <a
                        class="filled-btn"
                        href="https://cloud.trinka.ai/signup?_rg=JP"
                        target="_blank"
                        >始める</a
                     >
                  </div>
                  <span class="note">プレミアムプラスプラン限定</span>
               </div>
               <div class="top-banner-right">
                  <img
                     alt="Translator Tool"
                     height="360"
                     priority=""
                     src="assets/images/features/translation/language-translation-file.png"
                     width="492"
                  />
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section class="section-pd section-how-it-works">
   <div class="trinka_container container">
      <div class="row justify-content-center">
         <div class="col-md-12 col-lg-12">
            <div class="trinka-title text-center">
               <h2>そのメッセージを、洗練された英文に。</h2>
               <div class="HeadingSubLine1 justify-content-center">
                  <span></span><span></span><span></span>
               </div>
               <p class="w-70">
                  あなたのアイデアを国際ジャーナルを見据えた英文に。Trinka（トリンカ）のファイル翻訳機能がどのようなものでどのように使えるか、ウォークスルー動画でご覧いただけます。
               </p>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-6 col-md-5">
            <ul class="mt-2">
               <li>
                  <div class="login_circle_section bg-light-purple">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 3V15M12 3L17 8M12 3L7 8M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#763393" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <p class="mt-2">
                     <a
                        class="text-link"
                        data-target="#supportedLanguageModal"
                        data-toggle="modal"
                        href="#"
                        >日本語（または他言語）</a>の<br/>
                     ファイルをアップロード
                  </p>
               </li>
               <li>
                  <!-- <span class="arrow">
                        <svg fill="#a8a8a8" width="64px" height="64px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#a8a8a8"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.489 31.975c-0.271 0-0.549-0.107-0.757-0.316-0.417-0.417-0.417-1.098 0-1.515l14.258-14.264-14.050-14.050c-0.417-0.417-0.417-1.098 0-1.515s1.098-0.417 1.515 0l14.807 14.807c0.417 0.417 0.417 1.098 0 1.515l-15.015 15.022c-0.208 0.208-0.486 0.316-0.757 0.316z"></path> </g></svg>
                    </span> -->
                  <div class="login_circle_section bg-light-purple">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5.828H7.7M7.7 5.828H9.5M7.7 5.828V5M11 5.828H9.5M9.5 5.828C9.184 6.959 8.52 8.029 7.764 8.969L8.921 10.172M5.836 11C6.52771 10.3717 7.17213 9.69316 7.764 8.97C7.379 8.517 6.839 7.786 6.684 7.455M13.5 19L14.333 17M14.333 17L16 13L17.667 17M14.333 17H17.667M18.5 19L17.667 17" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 10V8C14 5.172 14 3.757 13.121 2.879C12.243 2 10.828 2 8 2C5.172 2 3.757 2 2.879 2.879C2 3.757 2 5.172 2 8C2 10.828 2 12.243 2.879 13.121C3.757 14 5.172 14 8 14H10" stroke="#763393" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M10 16C10 13.172 10 11.757 10.879 10.879C11.757 10 13.172 10 16 10C18.828 10 20.243 10 21.121 10.879C22 11.757 22 13.172 22 16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22C13.172 22 11.757 22 10.879 21.121C10 20.243 10 18.828 10 16Z" stroke="#763393" stroke-width="1.5"/>
                        <path d="M4 16.5C4 17.904 4 18.607 4.337 19.111C4.48296 19.3295 4.67053 19.517 4.889 19.663C5.393 20 6.096 20 7.5 20M20 7.5C20 6.096 20 5.393 19.663 4.889C19.517 4.67053 19.3295 4.48296 19.111 4.337C18.607 4 17.904 4 16.5 4" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> 
                  </div>
                  <p class="mt-2">英語またはスペイン語への自動翻訳</p>
                  <!-- <span class="arrow arrow1">
                        <svg fill="#a8a8a8" width="64px" height="64px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#a8a8a8"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.489 31.975c-0.271 0-0.549-0.107-0.757-0.316-0.417-0.417-0.417-1.098 0-1.515l14.258-14.264-14.050-14.050c-0.417-0.417-0.417-1.098 0-1.515s1.098-0.417 1.515 0l14.807 14.807c0.417 0.417 0.417 1.098 0 1.515l-15.015 15.022c-0.208 0.208-0.486 0.316-0.757 0.316z"></path> </g></svg>
                    </span> -->
               </li>
               <li>
                  <div class="login_circle_section bg-light-purple">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 20.8275V22.0005H14.173C14.583 22.0005 14.787 22.0005 14.972 21.9245C15.156 21.8485 15.3 21.7035 15.59 21.4145L20.413 16.5895C20.686 16.3165 20.823 16.1795 20.896 16.0335C21.035 15.7535 21.035 15.4235 20.896 15.1435C20.823 14.9965 20.686 14.8605 20.413 14.5875C20.14 14.3145 20.003 14.1775 19.857 14.1045C19.7187 14.0358 19.5664 14 19.412 14C19.2576 14 19.1053 14.0358 18.967 14.1045C18.82 14.1775 18.683 14.3145 18.41 14.5875L13.587 19.4115C13.297 19.7005 13.153 19.8455 13.077 20.0295C13.001 20.2135 13 20.4175 13 20.8275Z" stroke="#763393" stroke-width="1.5" stroke-linejoin="round"/>
                        <path d="M19 11C19 11 19 9.43 18.848 9.063C18.696 8.696 18.407 8.406 17.828 7.828L13.092 3.092C12.593 2.593 12.344 2.344 12.034 2.196C11.9698 2.16518 11.9041 2.13781 11.837 2.114C11.514 2 11.161 2 10.456 2C7.211 2 5.588 2 4.489 2.886C4.26709 3.06494 4.06494 3.26709 3.886 3.489C3 4.59 3 6.211 3 9.456V14C3 17.771 3 19.657 4.172 20.828C5.235 21.892 6.886 21.99 10 22M12 2.5V3C12 5.828 12 7.243 12.879 8.121C13.757 9 15.172 9 18 9H18.5" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> 
                  </div>
                  <p class="mt-2">
                     ファイルのダウンロード<br/>
                     またはTrinka Cloudでの編集
                  </p>
               </li>
            </ul>
         </div>
         <div class="col-lg-6 col-md-7">
            <div class="list-wrapper-image mt-2">
               <a
                  data-target="#youtubeModalPopup"
                  data-toggle="modal"
                  href=""
                  id="VewiVideoSection"
               >
                  <span
                     ><img alt="youtube" src="assets/images/youtube-icon.png"
                  /></span>
                  <img
                     alt="proofread for grammar errors"
                     class="img-fluid eposter-img"
                     height="450"
                     src="assets/images/features/translation/translation-thumbnail.webp"
                     width="800"
                  />
               </a>
            </div>
         </div>
      </div>
   </div>
</section>
<section class="section-pd list-wrapper-style-2">
   <div class="trinka_container container">
      <div class="row justify-content-center">
         <div class="col-md-12 col-lg-11">
            <div class="trinka-title mb-0 text-center">
               <h2>アカデミックライティングに特化した翻訳機能</h2>
               <div class="HeadingSubLine1 justify-content-center">
                  <span></span><span></span><span></span>
               </div>
               <p>
                  Trinkaの翻訳機能は、専門用語の語法、学術的な文体、原文の意図を保持し、校正や出版に適した正確な英文（またはスペイン語文章）に翻訳します。
               </p>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-6 col-md-6">
            <div
               class="list-wrapper-content-2 list-style-cards bt-none flex-title"
            >
               <div class="features_cards_icon">
                  <svg
                     fill="none"
                     height="40"
                     viewbox="0 0 40 40"
                     width="40"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M25.8332 13.3333C25.8332 11.1232 24.9552 9.00358 23.3924 7.44078C21.8296 5.87797 19.71 5 17.4998 5C15.2897 5 13.1701 5.87797 11.6073 7.44078C10.0445 9.00358 9.1665 11.1232 9.1665 13.3333C9.1665 15.5435 10.0445 17.6631 11.6073 19.2259C13.1701 20.7887 15.2897 21.6667 17.4998 21.6667C19.71 21.6667 21.8296 20.7887 23.3924 19.2259C24.9552 17.6631 25.8332 15.5435 25.8332 13.3333Z"
                        stroke="#763393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                     ></path>
                     <path
                        d="M5.83325 33.3331C5.83301 31.285 6.37191 29.273 7.39578 27.4993C8.41964 25.7255 9.89239 24.2525 11.666 23.2284C13.4396 22.2043 15.4515 21.6651 17.4996 21.665C19.5476 21.665 21.5596 22.2041 23.3333 23.2281M33.6482 24.8897L32.6099 23.8514C32.2777 23.5193 31.8272 23.3328 31.3574 23.3328C30.8877 23.3328 30.4371 23.5193 30.1049 23.8514L24.5233 29.4347C23.7827 30.1767 23.2772 31.1205 23.0699 32.1481L22.4999 34.9997L25.3499 34.4297C26.3787 34.2231 27.3237 33.7176 28.0666 32.9764L33.6482 27.3947C33.9803 27.0625 34.1669 26.612 34.1669 26.1422C34.1669 25.6725 33.9803 25.222 33.6482 24.8897Z"
                        stroke="#763393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                     ></path>
                  </svg>
               </div>
               <div class="features_cards_desc">
                  <h3>高度な学術翻訳</h3>
                  <p>原文の意味や科学的な記述を保ちます。</p>
               </div>
            </div>
         </div>
         <div class="col-lg-6 col-md-6">
            <div class="list-wrapper-content-2 list-style-cards flex-title">
               <div class="features_cards_icon">
                  <img
                     alt="retain original formatting"
                     height="40"
                     src="assets/images/RetainOriginalFormatting.png"
                     width="40"
                  />
               </div>
               <div class="features_cards_desc">
                  <h3>フォーマットの維持</h3>
                  <p>原文の書式を維持して翻訳します。</p>
               </div>
            </div>
         </div>
         <div class="col-lg-6 col-md-6">
            <div
               class="list-wrapper-content-2 list-style-cards flex-title bt-1"
            >
               <div class="features_cards_icon">
                  <svg
                     fill="none"
                     height="40"
                     viewbox="0 0 40 40"
                     width="40"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M8.33325 9.94301H13.5833M13.5833 9.94301H17.0833M13.5833 9.94301V8.33301M19.9999 9.94301H17.0833M17.0833 9.94301C16.4666 12.143 15.1799 14.223 13.7083 16.0513M13.7083 16.0513C12.4916 17.5663 11.1466 18.9063 9.95825 19.9997M13.7083 16.0513C12.9583 15.1713 11.9083 13.7497 11.6083 13.1063M13.7083 16.0513L15.9583 18.3897"
                        stroke="#763393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                     ></path>
                     <path
                        d="M11.7033 28.2963C11.7949 31.163 12.1066 32.9213 13.1799 34.2297C13.4567 34.5669 13.766 34.8762 14.1033 35.153C15.9499 36.6663 18.6866 36.6663 24.1666 36.6663C29.6466 36.6663 32.3849 36.6663 34.2299 35.153C34.5677 34.8752 34.8755 34.5675 35.1532 34.2297C36.6666 32.383 36.6666 29.6463 36.6666 24.1663C36.6666 18.688 36.6666 15.948 35.1532 14.103C34.8764 13.7658 34.5672 13.4565 34.2299 13.1797C32.9266 12.1113 31.1783 11.7963 28.3333 11.7047M11.7033 28.2963C8.83658 28.2047 7.07825 27.893 5.76992 26.8197C5.43267 26.5429 5.12341 26.2336 4.84659 25.8963C3.33325 24.0497 3.33325 21.313 3.33325 15.833C3.33325 10.3547 3.33325 7.61467 4.84659 5.76967C5.12341 5.43242 5.43267 5.12316 5.76992 4.84634C7.61659 3.33301 10.3533 3.33301 15.8333 3.33301C21.3116 3.33301 24.0516 3.33301 25.8966 4.84634C26.2338 5.12316 26.5431 5.43242 26.8199 5.76967C27.8932 7.07801 28.2049 8.83634 28.2966 11.703L28.3333 11.7047M11.7033 28.2963L28.3333 11.7047"
                        stroke="#763393"
                        stroke-width="2"
                     ></path>
                     <path
                        d="M21.6665 31.666L23.0548 28.3327M23.0548 28.3327L25.8332 21.666L28.6115 28.3327M23.0548 28.3327H28.6115M29.9998 31.666L28.6115 28.3327"
                        stroke="#763393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                     ></path>
                  </svg>
               </div>
               <div class="features_cards_desc">
                  <h3>多くの言語への対応</h3>
                  <p>
                    <a 
                        class="text-link"
                        data-target="#supportedLanguageModal"
                        data-toggle="modal"
                        href="#"
                    >30以上の言語
                    </a>からの翻訳が可能です。
                  </p>
               </div>
            </div>
         </div>
         <div class="col-lg-6 col-md-6">
            <div
               class="list-wrapper-content-2 list-style-cards flex-title bt-1"
            >
               <div class="features_cards_icon">
                  <svg
                     fill="none"
                     height="40"
                     viewbox="0 0 40 40"
                     width="40"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M8.9365 2C7.09683 2 5.3325 2.73089 4.03166 4.03189C2.73081 5.33289 2 7.09743 2 8.93732V27.4368C2 29.2767 2.73081 31.0413 4.03166 32.3423C5.3325 33.6433 7.09683 34.3742 8.9365 34.3742H16.3817L16.8719 32.4202C16.9018 32.2998 16.9349 32.1803 16.9713 32.0617H8.9365C7.71005 32.0617 6.53384 31.5745 5.6666 30.7071C4.79937 29.8398 4.31217 28.6634 4.31217 27.4368V11.2498H32.0582V16.4111C32.7981 16.0943 33.5819 15.9186 34.3704 15.8816V8.93732C34.3704 7.09743 33.6395 5.33289 32.3387 4.03189C31.0378 2.73089 29.2735 2 27.4338 2H8.9365ZM4.31217 8.93732C4.31217 7.71073 4.79937 6.53437 5.6666 5.66704C6.53384 4.7997 7.71005 4.31244 8.9365 4.31244H27.4338C28.6603 4.31244 29.8365 4.7997 30.7037 5.66704C31.571 6.53437 32.0582 7.71073 32.0582 8.93732H4.31217ZM20.4511 30.6211L31.6189 19.452C32.4302 18.6412 33.5303 18.186 34.6772 18.1864C35.8241 18.1868 36.9239 18.6429 37.7346 19.4543C38.5452 20.2657 39.0004 21.3659 39 22.513C38.9996 23.66 38.5435 24.7599 37.7322 25.5707L26.5645 36.7375C25.9137 37.3882 25.0986 37.8501 24.2061 38.0741L20.7424 38.9389C20.398 39.0248 20.0373 39.02 19.6952 38.9252C19.3532 38.8304 19.0415 38.6488 18.7904 38.3979C18.5393 38.147 18.3574 37.8354 18.2623 37.4934C18.1671 37.1514 18.1621 36.7906 18.2476 36.4461L19.1147 32.9821C19.3386 32.0894 19.8005 31.2742 20.4511 30.6234"
                        fill="#763393"
                     ></path>
                  </svg>
               </div>
               <div class="features_cards_desc">
                  <h3>同じツール上で訳文を修正</h3>
                  <p>
                     原稿の翻訳と添削・修正を同じツール上で行えます。
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
<section class="list-wrapper-style-2 section-pd pt-0 translation-type">
   <div class="trinka_container">
      <div class="row justify-content-center">
         <div class="col-lg-12 col-md-12">
            <div class="trinka-title text-center mb-0">
               <h2>ワークフローに合わせた2つの翻訳モード</h2>
               <div class="HeadingSubLine1 justify-content-center">
                  <span></span><span></span><span></span>
               </div>
            </div>
         </div>
      </div>
      <div class="row match-box">
         <div class="col-sm-6 dflex">
            <div class="editingMode c-card">
               <div class="list-wrapper-content-2">
                  <h3>ファイル翻訳</h3>
                  <p>
                     Wordファイルをアップロードすると、ファイル全体が英語（またはスペイン語）に翻訳されダウンロードできます。
                  </p>
               </div>
               <div class="grammar-checker-eg">
                  <img
                     alt="file translation"
                     class="img-fluid"
                     loading="lazy"
                     src="assets/images/features/translation/file-translation.png"
                  />
               </div>
            </div>
         </div>
         <div class="col-sm-6 dflex">
            <div class="editingMode c-card">
               <div class="list-wrapper-content-2 pr-80">
                  <h3>リアルタイム翻訳</h3>
                  <p>
                     日本語で入力すれば、エディタ内で即時に訳文が生成されます。
                  </p>
               </div>
               <div class="grammar-checker-eg">
                  <img
                     alt="edit translation"
                     class="img-fluid"
                     loading="lazy"
                     src="assets/images/features/translation/edit-tanslation.png"
                  />
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<div class="importFiles section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-lg-5">
                <div class="trinka-title mb-0">
                    <h3>クラウドストレージ、<br/>
                     ローカルディスクなど、<br/>
                     ファイルのインポート元を<br/>
                     選べます</h3>
                </div>
            </div>
            <div class="col-lg-7">
                <ul>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4f4f4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>Trikaのマイドライブ</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4f4f4f"/>
                                <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>ローカルディスク</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8871)">
                                <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8871">
                                <rect width="24" height="20.4375" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >DropBox</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                            </svg>
                        </div>
                        <p >Google Drive</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>



<div class="trinka-credits section-pd pb-0">
   <div class="trinka_container">
      <div class="row justify-content-center">
         <div class="col-md-10 col-lg-12">
            <div class="trinka-title mb-0 text-center">
               <h2>Trinkaトークンの利用によるファイル翻訳</h2>
               <div class="HeadingSubLine1 justify-content-center">
                  <span></span><span></span><span></span>
               </div>
            </div>
         </div>
         <div class="col-md-12 col-lg-11">
            <div class="credit-section">
               <div class="shape">
                  <svg
                     fill="none"
                     height="140"
                     viewbox="0 0 745 140"
                     width="745"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z"
                        fill="#F5ECFF"
                     ></path>
                  </svg>
               </div>
               <div class="media">
                  <div class="media-left">
                     <img
                        alt="credits"
                        decoding="async"
                        loading="lazy"
                        src="assets/images/new-credits.svg"
                     />
                  </div>
                  <div class="media-body">
                     <h6>
                        1ファイル（上限50,000文字）あたり5Trinkaトークンを消費<br/>
                        プレミアムプラスプラン限定の機能です
                     </h6>
                  </div>
               </div>
               <div class="image">
                  <img
                     alt="credits"
                     decoding="async"
                     loading="lazy"
                     src="assets/images/credits-banner.svg"
                  />
               </div>
            </div>
            <ul>
               <li>
                  <span>*</span>
                  <p>
                     Trinkaの特定の機能をお使いいただく上で、それぞれ決められたポイント数が必要になります。<br/>
                     毎月、プレミアムプランのユーザーには10ポイント、ベーシックプランのユーザーには4ポイントが無料で進呈されます。<br/>
                     詳しくは
                     <a
                        class="text-link"
                        [routerLink]="['/features/credits']"
                     >Trinkaトークンのページ</a>をご覧ください。<br/>
                     ポイントを追加でご購入される場合、まとめての購入で最大40％の割引が適用されます。
                     
                  </p>
               </li>
            </ul>
         </div>
      </div>
   </div>
</div>
<div #target="" class="faqQuestionAnwser section-pd">
   <div class="trinka_container">
      <div class="row justify-content-center">
         <div class="col-lg-8 col-md-10">
            <div class="trinka-title text-center">
               <h2>よくあるご質問</h2>
               <div class="HeadingSubLine1 justify-content-center">
                  <span></span><span></span><span></span>
               </div>
            </div>
         </div>
      </div>
      <div class="faqQuestionsList">
         <div class="accordion" id="faq">
            <div class="row">
               <div class="col-lg-6">
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionOne">
                           <a
                              aria-controls="QuestionOneContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionOneContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaでのファイル翻訳に掛かる時間は？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionOne"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionOneContent"
                        >
                           <div class="card-body">
                              <p>
                                 ファイルサイズや体裁の複雑さにもよりますが、Trinkaのファイル翻訳機能では、通常、数秒から数分でファイル全体の翻訳が完了します。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionTwo">
                           <a
                              aria-controls="QuestionTwoContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionTwoContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaのファイル翻訳機能で、一度に複数のファイルを翻訳できるか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionTwo"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionTwoContent"
                        >
                           <div class="card-body">
                              <p>
                                 現在、Trinkaのファイル翻訳機能では、同時に翻訳できるのは1ファイルのみです。
                              </p>
                              <p>
                                 複数のファイルを翻訳する場合には、順番にファイルをアップロードしていただく必要があります。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionThree">
                           <a
                              aria-controls="QuestionThreeContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionThreeContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           ファイル翻訳機能で翻訳できるファイル形式は？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionThree"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionThreeContent"
                        >
                           <div class="card-body">
                              <p>
                                 Trikaのファイル翻訳機能が対応しているのはMicrosoft Wordの文書（「.doc」および「..docx」）です。
                              </p>
                              <p>
                                 それ以外のファイルをアップロードされた場合、Word形式の文書のアップロードをお願いするメッセージが表示されます。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionFour">
                           <a
                              aria-controls="QuestionFourContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionFourContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaのファイル翻訳機能の使用量に限度はあるか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionFour"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionFourContent"
                        >
                           <div class="card-body">
                              <p>
                                 Trinkaの翻訳機能のご利用に、1日あたりの制限は設けられていません。
                              </p>
                              <p>
                                 ただし、各ファイルの翻訳には5Trinkaトークンが必要となります。お持ちのポイント数をご確認の上ご利用ください。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionFive">
                           <a
                              aria-controls="QuestionFiveContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionFiveContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaのツール上で翻訳後の文書の修正はできるか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionFive"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionFiveContent"
                        >
                           <div class="card-body">
                              <p>
                                 はい。ファイル翻訳の完了後、Trinka Cloudのエディター上で直接翻訳内容の確認と編集を行えます。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-lg-6">
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionSix">
                           <a
                              aria-controls="QuestionSixContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionSixContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           アップロードしたファイルの翻訳を中止できるか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionSix"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionSixContent"
                        >
                           <div class="card-body">
                              <p>
                                 ファイル翻訳のプロセスは、一度開始すると途中で取り止めることはできません。
                              </p>
                              <p>ただし、翻訳後の文書はいつでも編集・修正、削除することができます。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionSeven">
                           <a
                              aria-controls="QuestionSevenContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionSevenContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaの翻訳機能は、欧文以外の文字で書かれた言語にも対応しているか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionSeven"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionSevenContent"
                        >
                           <div class="card-body">
                              <p>
                                 Trinkaのファイル翻訳機能は、アラビア語、中国語、日本語、韓国語などの言語にも対応しています。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionEight">
                           <a
                              aria-controls="QuestionEightContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionEightContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           ファイル翻訳の際、ファイルの情報は守られるのか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionEight"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionEightContent"
                        >
                           <div class="card-body">
                              <p>
                                 Trinkaの翻訳は、厳格なプライバシーポリシー、セキュリティポリシーの下で行われます。
                              </p>
                              <p>
                                 ファイルは安全なクラウド上に置かれ、データの外部への共有や、AIによる学習は行われません。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionNine">
                           <a
                              aria-controls="QuestionNineContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionNineContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaの翻訳機能では文書のフォーマットや、学術的な文体は保たれるのか？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionNine"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionNineContent"
                        >
                           <div class="card-body">
                              <p>
                                 ファイル翻訳機能では、専門的な内容や文章の意味を正しく翻訳しながら、原文の書式を保持します。研究論文等、学術系の文書の草稿をまずは日本語で準備したいという方にはお勧めです。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="faqContainer">
                     <div class="card">
                        <div class="card-header" id="QuestionTen">
                           <a
                              aria-controls="QuestionTenContent"
                              aria-expanded="true"
                              class="btn btn-header-link collapsed"
                              data-target="#QuestionTenContent"
                              data-toggle="collapse"
                              href="#"
                           >
                           Trinkaの翻訳機能は誰にとって有用か？
                           </a>
                        </div>
                        <div
                           aria-labelledby="QuestionTen"
                           class="collapse"
                           data-parent="#faq"
                           id="QuestionTenContent"
                        >
                           <div class="card-body">
                              <p>
                                 Trinkaの翻訳機能は、英語を母語としない研究者や学生などの方々が、国際的な媒体での発信・出版を目指して英文作成する際の補助となることを念頭に、設計・公開されています。
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<div
   aria-hidden="true"
   aria-labelledby="supportedLanguageModal"
   class="modal fade"
   id="supportedLanguageModal"
   tabindex="-1"
>
   <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title">対応可能な翻訳ソース言語</h6>
            <button
               aria-label="Close"
               class="btn-close"
               data-dismiss="modal"
               type="button"
            ></button>
         </div>
         <div class="modal-body">
            <div class="row">
               <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <ul>
                     <!-- <li><b>AR</b> - Arabic</li> -->
                     <!-- <li><b>BG</b> - Bulgarian</li> -->
                     <li><b>CS</b> - チェコ後</li>
                     <li><b>DA</b> - デンマーク語</li>
                     <li><b>DE</b> - ドイツ語</li>
                     <li><b>EL</b> - ギリシャ語</li>
                     <li><b>EN</b> - 英語</li>
                     <li><b>ES</b> - スペイン語</li>
                     <li><b>ET</b> - エストニア語</li>
                     <li><b>FI</b> - フィンランド語</li>
                     <li><b>FR</b> - フランス語</li>
                     <li><b>HE</b> - ヘブライ語</li>
                     <li><b>HU</b> - ハンガリー語</li>
                  </ul>
               </div>
               <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <ul>
                     <li><b>ID</b> - インドネシア語</li>
                     <li><b>IT</b> - イタリア語</li>
                     <li><b>JA</b> - 日本語</li>
                     <li><b>KO</b> - 韓国語</li>
                     <li><b>LT</b> - リトアニア語</li>
                     <li><b>LV</b> - ラトビア語</li>
                     <li><b>NB</b> - ノルウェー語ブークモール</li>
                     <li><b>NL</b> - オランダ語</li>
                     <li><b>PL</b> - ポーランド語</li>
                     <li><b>PT</b> - ポルトガル語</li>
                     <li><b>RO</b> - ルーマニア語</li>
                  </ul>
               </div>
               <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <ul class="br-0">
                     <li><b>RU</b> - ロシア語</li>
                     <li><b>SK</b> - スロバキア語</li>
                     <li><b>SL</b> - スロベニア語</li>
                     <li><b>SV</b> - スウェーデン語</li>
                     <li><b>TH</b> - タイ語</li>
                     <li><b>TR</b> - トルコ語</li>
                     <li><b>UK</b> - ウクライナ語</li>
                     <li><b>VI</b> - ベトナム語</li>
                     <li><b>ZH</b> - 中国語</li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal video-modal" id="youtubeModalPopup">
   <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
         <div class="modal-body no-padding">
            <button
               (click)="stopAllVideos()"
               class="btn-close"
               data-dismiss="modal"
               type="button"
            ></button>
            <iframe
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
               allowfullscreen=""
               class="youtubeVideoForTryDemo"
               frameborder="0"
               height="450"
               id="iframe"
               src="https://www.youtube.com/embed/1WjQPgnR1eI?si=LiyS9Ih5j5jgJtEd"
               title="YouTube video player"
               width="100%"
            ></iframe>
         </div>
      </div>
   </div>
</div>
